import styled from "styled-components";

export const Main = styled.div`
  background-color: #f2f2f2;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  width: 100%;
`;

export const SpanColored = styled.span`
  padding: 5px;
  border-radius: 5px;
  width: fit-content;
`;

export const StyledDiv = styled.div`
  padding-top: 8svh;
  display: flex;
  background-color: inherit;
  height: 100%;
  min-height: 100%;
  padding-bottom: 150px;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  margin: 0;
`;

export const HeaderFilling = styled.div`
  background-color: #2e1654;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  width: inherit;
  max-height: 8dvh;
  z-index: 1;
  object-fit: cover;
  .title {
    white-space: nowrap;
    word-break: none;
    line-break: none;
    color: white;
    font-size: 1.5em;
    font-weight: bold;
  }
`;

export const TimeDiv = styled.div`
  display: flex;
  align-self: center;
  background-color: white;
  padding: 5px;
  border-radius: 5px;
  margin-bottom: 10px;
`;

export const Footer = styled.footer`
  padding: 20px;
  padding-bottom: 20px;
  align-items: center;
  justify-content: space-around;
  height: fit-content;
  width: 100%;
  display: flex;
`;

export const FooterContainer = styled.footer`
  position: fixed;
  bottom: 0;
  min-width: 100%;
  margin: 0;
  z-index: 1;
`;

export const FooterDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AxymaFooterDiv = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
`;
